import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const TOKEN_KEY = "mimo_token";

client.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

let refreshing = null;

client.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        const status = error.response?.status;
        if (status === 401 && !original._retry && !original.url.includes("/auth/")) {
            original._retry = true;
            try {
                if (!refreshing) refreshing = client.post("/auth/refresh");
                const { data } = await refreshing;
                refreshing = null;
                if (data.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
                original.headers.Authorization = `Bearer ${data.access_token}`;
                return client(original);
            } catch (e) {
                refreshing = null;
                localStorage.removeItem(TOKEN_KEY);
            }
        }
        return Promise.reject(error);
    }
);

export function apiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return "Algo no ha ido bien. Inténtalo de nuevo en un momento.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default client;
